/** Tipo de resgate que define o percentual resgatável. */
export enum RegraPercentualResgate {
  /** Resgate de todo o saldo. */
  Total = 'Total',
  /** Resgate de parte do saldo. */
  Parcial = 'Parcial',
}
